import {createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import {authStatus} from '@/utils/auth';

import Main from '@/modules/main/main.vue';
import Login from '@/modules/login/login.vue';
import Register from '@/modules/register/register.vue';



const routes: Array<RouteRecordRaw> = [
    //Login==========================================================
    {
        path: '/login',
        name: 'Login',
        component:  Login,
        meta: {
            requiresUnauth: true
        }
    },
    //Register========================================================
    {
        path: '/register',
        name: 'Register',
        component:  Register,
        meta: {
            requiresUnauth: true
        }
    },
    //Main===========================================================
    {
        path: '/',
        name: 'Main',
        component: Main,
        meta: {
            requiresAuth: true
        },
        children: [
            //Home===================================================
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/Home/HomeView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //Hasil===================================================
            {
                path: '/hasil/:id',
                name: 'hasil',
                component: () => import('@/views/Hasil/Hasil.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //Hasil===================================================
            {
                path: '/soal',
                name: 'soal',
                component: () => import('@/views/SoalView/SoalView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/soal/items/:id',
                name: 'soal_items',
                component: () => import('@/views/SoalItemsView/SoalItemsView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //About==================================================
            {
                path: '/about',
                name: 'about',
                component: () => import('@/views/About/AboutView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //User====================================================
            {
                path: '/user_profil/:username?/:tab?',
                name: 'user_profil',
                component: () => import('@/views/User/UserProfil/UserProfil.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //-------------------------------------------------------
            {
                path: '/user_list',
                name: 'user_list',
                component: () => import('@/views/User/UserList/UserList.vue'),
                meta: {
                    requiresAuth: true,
                }
            },

            //-------------------------------------------------------
            //=======================================================


//====================================================================
//====================================================================
            //Admin===================================================
            //User New List-------------------------------------------
            {
                path: '/admin/user_new_list',
                name: 'admin_user_new_list',
                component: () => import('@/views/Admin/UserNewList/UserNewList.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //--------------------------------------------------------
            //Basic---------------------------------------------------

            //++++++++BasicConfig+++++++++++++++++++++++++++++++++++++
            {
                path: '/admin/basic/basic_config',
                name: 'admin_basic_config',
                component: () => import('@/views/Admin/Basic/BasicConfig/BasicConfig.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            //++++++++RolePermission++++++++++++++++++++++++++++++++++
            {
                path: '/admin/basic/role_permission',
                name: 'admin_basic_role_permission',
                component: () => import('@/views/Admin/Basic/RolePermission/RolePermission.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            //++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            //++++++++RolePermission++++++++++++++++++++++++++++++++++
            {
                path: '/admin/basic/menus',
                name: 'admin_basic_menus',
                component: () => import('@/views/Admin/Basic/Menus/Menus.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //++++++++++++++++++++++++++++++++++++++++++++++++++++++++

            //--------------------------------------------------------
            //========================================================
//====================================================================
//====================================================================
            //ATT=====================================================
            //Alamat--------------------------------------------------
            {
                path: '/att/base/alamat',
                name: 'att_base_alamat',
                component: () => import('@/views/Att/Alamat/AlamatView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //Alamat--------------------------------------------------
            //Gender--------------------------------------------------
            {
                path: '/att/base/gender',
                name: 'att_base_gender',
                component: () => import('@/views/Att/Gender/GenderView.vue'),
                meta: {
                    requiresAuth: true,
                }
            },
            //Gender--------------------------------------------------
            //ATT=====================================================
//====================================================================
//====================================================================
        ]
    }
];

const router = createRouter({
    //history: createWebHistory(import.meta.env.BASE_URL),//
    history: createWebHistory(process.env.VUE_APP_BASE_URL),//
    routes,
    linkActiveClass: 'font-bold',
    linkExactActiveClass: ''
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (await authStatus()) {
            next();
        } else {
            next('login');
        }
    } else {
        next();
    }
});

export default router;
